import { render } from "./Reporting.vue?vue&type=template&id=5ec144cc"
import script from "./Reporting.vue?vue&type=script&lang=js"
export * from "./Reporting.vue?vue&type=script&lang=js"
script.render = render

export default script